import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    FormControl,
    FormLabel,
    Select
} from "@chakra-ui/react"
import { useRef } from "react"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { monthIsLoading, setHolidayType } from "../../redux/actions/actions"
import { changeCalendarSlotType } from "../../redux/api_calls/apiCalls"

export default function EditCalendarSlotModal({ currentValue, title, isOpen, onClose, date, id }) {
    const [selectedValue, setSelectedValue] = useState(currentValue)
    const [isLoading, setIsLoading] = useState(false)
    const selectRef = useRef()
    const dispatch = useDispatch()

    const changeHandler = () => {
        setSelectedValue(selectRef.current.value)
    }

    const clickHandler = async() => {
        setIsLoading(true)
        try {
            let response = await changeCalendarSlotType(id, date, selectedValue)
            if (response) {
                dispatch(monthIsLoading())
                dispatch(setHolidayType({day: Number(date.split('-')[2]) - 1, type: selectedValue}))
                setIsLoading(false)
                onClose()
            }
        }
        catch (error) {
            setIsLoading(false)
            console.log(error)
        }
    }

    useEffect(() => {
        return () => setSelectedValue('')
        // eslint-disable-next-line
    }, [])

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{title}</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <FormControl>
                        <FormLabel
                            variant="custom"
                            htmlFor='type'
                            style={{ fontFamily: "Mulish, sans-serif" }}
                        >
                            Type
                        </FormLabel>
                        <Select
                            id='type'
                            width={["100%", "100%", "90%", "85%"]}
                            bgColor="white"
                            border='1px solid rgba(0, 0, 0, 0.1)'
                            borderRadius="13px"
                            height='40px'
                            ref={selectRef}
                            value={selectedValue}
                            onChange={changeHandler}
                        >
                            <option key='1' value="1">Working Day</option>
                            <option key='2' value="2">Government Holiday</option>
                            <option key='3' value="3">Weekly Holiday</option>
                        </Select>
                    </FormControl>
                    

                </ModalBody>

                <ModalFooter>
                    <Button colorScheme='gray' mr={3} onClick={onClose}>
                        Cancel
                    </Button>
                    <Button
                        colorScheme='messenger'
                        onClick={clickHandler}
                        isLoading = {isLoading}
                    >
                        Set
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}